import React, { useMemo, useState, useEffect, useLayoutEffect, useRef } from 'react';
import classnames from 'classnames';
import './index.scss';
import { entityTypeMsg } from '@/pages/intelligence/utils/topchartsUtils';
import { useIntl, getLocale, history, useSelector } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import {
  getFollowing,
  setFollowing,
  getDetailCombinedIds,
} from '@/pages/intelligence/services/topcharts';
import { Button, Bubble } from 'tea-component';
import RenameAddGroup from '@/pages/intelligence/pages/Following/Manage/RenameAddGroup';
import AddGroup from '@/pages/intelligence/pages/Following/Manage/AddGroup';
import GameHeader from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/GameHeader';
import CompanyAndGenre from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/CompanyAndGenre';
import { FormMode } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { fetchFollowingGroups } from '@/pages/intelligence/services/following';
import {
  namespace as USER_GUIDE_NAMESPACES,
  GUIDE_TYPE_INTELLIGENCE_FOLLOWING,
} from '@home/models/guide';
import {
  GuideFollowingDelay as GuideFollowing,
  FOLLOWING_GUIDE_CLASSNAMES,
} from '@intelligence/components/UserGuide/Following';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { LANGUAGE_CN } from '@intelligence/_config/config';
const DEFAULT_GROUPNAME = 'All Games'; // 默认是All Games

/**
 * Following新手引导 需要用到的逻辑，主要是自动打开 Following收藏分组设置的弹窗，用于引导的高亮区域
 * 非Following新手引导模式下，不执行任何逻辑
 * @param props 打开Following分组设置弹窗的方法，目前该方法内已有 获取当前分组数据接口的逻辑了，直接复用
 * @returns 是否初始化完成，即已自动打开Following分组设置的弹窗
 */
function useFollowingUserGuide(props: {
  followingGroupSelectModalInitialHandler: () => void;
  setFollowingGroupSelectModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { followingGroupSelectModalInitialHandler, setFollowingGroupSelectModalVisible } = props;

  const { guideType } = useSelector((state: any) => state?.[USER_GUIDE_NAMESPACES] || {});
  const isFollowingUserGuideMode = guideType === GUIDE_TYPE_INTELLIGENCE_FOLLOWING;

  const [isInited, setIsInited] = useState(false);

  useEffect(() => {
    if (!isFollowingUserGuideMode) {
      setFollowingGroupSelectModalVisible(false);
      return;
    }

    (async () => {
      await followingGroupSelectModalInitialHandler();
      setIsInited(true);
    })();

    return () => {
      setIsInited(false);
    };
  }, [isFollowingUserGuideMode]);

  return {
    isFollowingUserGuideMode,
    isInited,
  };
}

const HeaderComonents = (props: any) => {
  const {
    basicInfo,
    gameDetails,
    genreOptionsMap,
    appIdListAll,
    appIdList,
    setAppIdList,
    userInfo,
    entityType = 'mobile',
    activeId,
    req,
    receiveSumFun,
    listTab,
    storage,
    combineGameIdList,
    isDisabledSteamOverlap,
    isOverlapDisabled,
    releaseTime,
  } = props;

  // console.log('HeaderComonents',props);

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;
  const [action, setAction] = useState(false);
  const [createNewGroup, setCreateNewGroup] = useState(false);
  const [addGroup, setAddGroup] = useState(false);
  const [isHeaderBgNew, setIsHeaderBgNew] = useState(false);
  const [favarite, setFavarite] = useState<any>(false);
  const [groupOptions, setGroupOptions] = useState<any[]>([]);
  const [addNewGroupName, setAddNewGroupName] = useState('');
  const [domeHeight, setDomHeight] = useState(0);
  const [windowSize, setWindowSize] = useState<any>(null);
  const dom = useRef(null);

  const combinedGameList = useMemo<
  {
    id: string;
    entity_type: string;
    is_opinions?: boolean;
    [key: string]: any;
  }[]
  >(() => {
    if (!Array.isArray(combineGameIdList)) return [];
    let list: any = [];
    const listTemp = combineGameIdList.filter((item) => item?.entity_type !== entityType);
    const pcConsoleGame = combineGameIdList?.filter((item) =>
      ['pc', 'console'].includes(item?.entity_type),
    );
    if (Array.isArray(pcConsoleGame) && pcConsoleGame?.length < 1 && entityType === 'mobile') {
      list = [];
    } else {
      list = listTemp;
    }
    return list;
  }, [entityType, combineGameIdList]);

  const isPCConsoleCombine = entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE;

  // 新增、重命名分组 区分标识
  const MODE = FormMode.Add;

  const getFollowingStatus = async (game_company_id: any) => {
    const result = await getFollowing({
      user_id: userInfo.userid,
      game_company_id,
    });
    if (result?.data === 'true' || result?.data === '已收藏') {
      setFavarite(true);
    } else {
      setFavarite(false);
    }
  };

  const changeFavarite = async () => {
    if (!req?.id) return;
    // console.log('favarite', favarite)

    if (!favarite) {
      handleGroupSettingPre();
    } else {
      await setFollowing({
        user_id: userInfo.userid,
        game_company_id: req?.id,
        entity_type: req?.entity_type,
        is_collection: !favarite,
      })
        .then((res: any) => {
          getFollowingStatus(req?.id);
        })
        .catch((err: any) => {
          // setIsVisualisLoading(false);
          // setIsError(true);
        });
    }
  };

  const handleGroupSettingPre = async () => {
    try {
      const params = {
        entity_type: entityType,
      };
      const res = await fetchFollowingGroups(params);
      const groupList = res?.data?.group_lists;
      const groupOption = groupList?.map((item: any) => ({
        value: item?.entity_name,
        text: `${item?.entity_name} (${item?.game_list_total})`,
      }));
      setGroupOptions(groupOption);
      setAddGroup(true);
    } catch (exception) {
      setGroupOptions([
        {
          value: DEFAULT_GROUPNAME,
          text: `${DEFAULT_GROUPNAME} (0)`,
        },
      ]);
      console.warn(exception);
    }
  };

  const handleAddGroupClose = () => {
    setAddNewGroupName('');
    setAddGroup(false);
  };

  useEffect(() => {
    // 等basicinfo返回时再请求别的接口
    if (req?.id) {
      // pc、console不支持following功能，所以可以不用查询游戏是否收藏
      if (!isPCConsoleCombine) {
        getFollowingStatus(req?.id);
      }
      // getCombinedGameId(req?.entity_type, req?.id);
      // 目前只cs2游戏，需要用新的背景图片效果
      if (req?.id == 'e9ec9568bb80051c45b5d19204249d6f0') {
        setIsHeaderBgNew(true);
      }
    }
  }, [req?.id, isPCConsoleCombine]);

  useEffect(() => {
    window.addEventListener('resize', () => setWindowSize(window.innerWidth));
    return () => {
      window.removeEventListener('resize', () => setWindowSize(window.innerWidth));
    };
  }, []);

  useLayoutEffect(() => {
    setDomHeight(dom?.current?.offsetHeight);
  }, [windowSize]);

  const { isFollowingUserGuideMode, isInited } = useFollowingUserGuide({
    followingGroupSelectModalInitialHandler: handleGroupSettingPre,
    setFollowingGroupSelectModalVisible: setAddGroup,
  });

  const setAddGroupHandle = (val: any) => {
    handleGroupSettingPre();
    setAddGroup(val);
  };

  const isOnlyOneCombinedGames = combinedGameList?.length === 1;

  const getActiveIdCur = (item: any, pathType: string) => {
    // console.log('activeId', activeId)
    // console.log('pathType', pathType)
    switch (activeId) {
      case 'opinions':
        return item.is_opinions ? 'opinions' : 'overview';
      case 'overlap': {
        if (pathType === 'mobileGames') {
          return isOverlapDisabled ? 'overview' : 'overlap';
        }
        if (pathType !== 'consoleGames') {
          return isDisabledSteamOverlap ? 'overview' : 'overlap';
        }
      }
      default:
        return activeId;
    }
  };

  return (
    <>
      <div className="dbi-details-header-between">
        {/* 暂时先放头像， 后续需要开发传入需要的背景 */}
        <div className={isHeaderBgNew ? 'dbi-header-bg-new' : 'dbi-header-bg'}>
          {/* <img src={basicInfo?.image} /> */}
          <div
            className="dbi-header-bg-img"
            style={{ backgroundImage: `url(${basicInfo?.image})` }}
          />
        </div>
        <div className="dbi-details-header-left">
          <GameHeader
            basicInfo={basicInfo}
            appIdListAll={appIdListAll || []}
            gameName={basicInfo?.name || ''}
            appIdList={appIdList || []}
            receiveSumFun={receiveSumFun}
            entityType={entityType}
            setAppIdList={setAppIdList}
            storage={storage}
            dom={dom}
            combinedGameList={combinedGameList}
            releaseTime={releaseTime}
          />
          <CompanyAndGenre
            basicInfo={basicInfo}
            gameDetails={gameDetails}
            listTab={listTab}
            entityType={entityType}
            domeHeight={domeHeight}
            genreOptionsMap={genreOptionsMap}
          />
        </div>

        <div className="dbi-details-header-right">
          {/* pc、console联合游戏，不支持Following功能 */}
          {!isPCConsoleCombine && typeof favarite === 'boolean' && (
            <Button
              className={classnames(
                'dbi-details-btn dbi-details-btn-bottom ns-btn--shadow',
                FOLLOWING_GUIDE_CLASSNAMES.ELEMENT1_HIGHLIGHT2,
                {
                  'dbi-details-btn--block':
                    combinedGameList?.length >= 3 ||
                    (isOnlyOneCombinedGames &&
                      combinedGameList?.[0]?.entity_type === PC_CONSOLE_COMBINE_ENTITY_TYPE),
                },
              )}
              onClick={() => {
                changeFavarite();
              }}
            >
              <SvgIcon
                className={favarite ? 'is-select' : 'no-change'}
                type={favarite ? 'star-action' : 'star-m'}
              />
              {favarite
                ? formatMessage({ id: `dbi_detail_following` })
                : formatMessage({ id: `dbi_detail_follow` })}
            </Button>
          )}

          <div className="dbi-details-btn-flex">
            {combinedGameList?.map((item: any) => {
              const entityTypeMsgItem = entityTypeMsg[item?.entity_type];
              const messageKey =
                item?.entity_type === 'console' ? 'dbi_console_version' : entityTypeMsgItem?.name;
              const btnClassName1 = isOnlyOneCombinedGames
                ? 'dbi-details-btn-separate'
                : 'dbi-details-btn-item';
              const isItemPCConsoleCombine = item?.entity_type === PC_CONSOLE_COMBINE_ENTITY_TYPE;
              return (
                <React.Fragment key={`${item?.entity_type}-${item?.id}`}>
                  {entityTypeMsgItem && (
                    <Bubble dark content={formatMessage({ id: messageKey })}>
                      <Button
                        className={classnames('ns-btn--shadow', btnClassName1, {
                          'dbi-details-btn-separate-combine':
                            isOnlyOneCombinedGames && isItemPCConsoleCombine,
                          'dbi-details-btn-separate-combine-cn':
                            isOnlyOneCombinedGames && isItemPCConsoleCombine && isCN,
                        })}
                        onClick={() => {
                          history.push(
                            `/intelligence/topCharts/${entityTypeMsgItem.path}/gamesDetails/${
                              item?.id
                            }/${getActiveIdCur(item, entityTypeMsgItem.path)}`,
                          );
                        }}
                      >
                        <SvgIcon className="no-change" type={entityTypeMsgItem.icon} />
                        {combinedGameList?.length == 1 ? formatMessage({ id: messageKey }) : ''}
                      </Button>
                    </Bubble>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>

        <RenameAddGroup
          visible={createNewGroup}
          mainSegment={entityType}
          setCreateRenameGroup={setCreateNewGroup}
          mode={MODE}
          openAddUpateGroup={handleGroupSettingPre}
          setAddNewGroupName={setAddNewGroupName}
        />
        <AddGroup
          visible={addGroup}
          close={handleAddGroupClose}
          entityType={entityType}
          userInfo={userInfo}
          gameId={req?.id}
          setFavarite={setFavarite}
          setAddGroup={setAddGroupHandle}
          groupOptions={groupOptions}
          DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
          favarite={favarite}
          addNewGroupName={addNewGroupName}
          getCreateGroup={() => {
            setAddGroup(false);
            setCreateNewGroup(true);
            setAction(!action);
          }}
        />
      </div>
      {isFollowingUserGuideMode && typeof favarite === 'boolean' && isInited && <GuideFollowing />}
    </>
  );
};

export default HeaderComonents;
